import React from 'react';
import PropTypes from 'prop-types';

import hitToListItem from 'Components/Utility/SEO/hit-list-item';
import ErrorBoundary from 'Components/Utility/ErrorBoundary';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import { encodeSlug } from 'Helpers/Slug';
import { ScriptTag } from 'Helpers/SEO/Tags';

function ItemList({
  hits,
  nbHits,
  page,
  hitsPerPage,
  title,
  noLinks,
}) {
  if (!hits || !hits.length) {
    return false;
  }

  let fullUrl = window.location.href.split('?')[0];

  if (getUrlParameter('page')) {
    fullUrl = `${fullUrl}?page=${getUrlParameter('page')}`;
  }

  let pageStart = 0;
  let numberOfItems = hits.length;

  if (nbHits) {
    numberOfItems = nbHits;
  }

  if (page && hitsPerPage) {
    pageStart = (page - 1) * hitsPerPage;
  }


  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@id': `${fullUrl}#${encodeSlug(title)}${title ? '-' : ''}itemlist`,
    '@type': 'ItemList',
    name: title || undefined,
    numberOfItems,
    itemListElement: hits.map((h, i) => hitToListItem(h, i + pageStart, noLinks)),
  });

  // Use an id for slugs, because translated titles can mess with ids
  const id = hits.map(h => encodeSlug(h.slug)).join('-');

  return <ScriptTag id={`item-list-${id}-schema`} type="application/ld+json" script={schema} />;
}

export default function ItemListWrapper(props) {
  return (
    <ErrorBoundary hideForm>
      <ItemList {...props} />
    </ErrorBoundary>
  );
}

ItemList.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  title: PropTypes.string,
  nbHits: PropTypes.number,
  page: PropTypes.number,
  hitsPerPage: PropTypes.number,
  noLinks: PropTypes.bool,
};

ItemList.defaultProps = {
  title: '',
  noLinks: false,
  nbHits: null,
  page: null,
  hitsPerPage: null,
};
